module.exports = __webpack_public_path__ + "img/waybil.a9434d53.svg";